import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import moment from 'moment';
import { Form } from 'reactstrap';
import QRCode from 'qrcode.react';
import { Link } from 'react-router-dom';

import { NewRegisterEssayModal } from './NewRegisterEssayModal';
import { Expander } from '../../../../../components/Common/Expander';
import Table1 from '../../../../../components/Common/TableContainer';
import TableNP from '../../../../../components/Common/TableContainerNP';
import { LabCitecDetailsTestEditModal } from './LabCitecDetailsTestEditModal';
import { TableItemDeleteModal } from '../../../../../components/Common/TableItemDeleteModal';
import { AnalysisRequestSaveButton } from '../../../../../components/Common/AnalysisRequestSaveButton';
import { AnalysisRequestLastUpdate } from '../../../../../components/Common/AnalysisRequestLastUpdate';
import { AnalysisRequestNotifyButton } from '../../../../../components/Common/AnalysisRequestNotifyButton';
import { AnalysisRequestNewRegisterButton } from '../../../../../components/Common/AnalysisRequestNewRegisterButton';
import { addNewLabRequestTest, deleteLabRequestTest, getLabRequestTests, updateLabRequestTest, massiveStatusUpdate, getLabRequestReports } from '../../../../../store/actions';
import { BaseCustomButton } from '../../../../../shared';
import { userRoles } from '../../../../../shared';
import { MassiveValidationModal } from './MassiveValidationModal';
import { toast } from 'react-toastify';

// Formik validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { requestStatus, statuses } from '../../../../../constants';
import { ConfirmationModalTestReport } from '../../../../../components/Common/ConfirmationModalTestReport';

export const LabCitecDetailsTests = ({ props, id, labRequest, updateTestStatus, status, generalStatus }) => {
  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''
  const [rowInfo, setRowInfo] = useState();
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showMassiveValidationModal, setShowMassiveValidationModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}`));
    dispatch(getLabRequestReports(`?limit=20&page=0&labRequest=${id}`));
  }, [])

  const { labRequestTests, loading, total, currentPage, labRequestReports } = useSelector(state => ({
    labRequestTests: state.labRequestTestReducer.labRequestTests,
    loading: state.labRequestTestReducer.loading,
    labRequestTest: state.labRequestTestReducer.labRequestTest,
    total: state.labRequestTestReducer.total,
    currentPage: state.labRequestTestReducer.currentPage,
    labRequestReports: state.labRequestReportReducer.labRequestReports,
  }), shallowEqual);

  const booleanValidation = React.useMemo(
    () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
    [generalStatus]
  );

  const reRender = () => {
    dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}`));
  }

  const recarga = () => {
    window.location.reload();
  }

  const validateReportsDates = (statusVal) => {
    if (statusVal === 'Autorizado') {
      const report = (labRequestReports && labRequestReports.length > 0)
        ? labRequestReports[0]
        : (labRequest?.labRequestReport && labRequest.labRequestReport.length > 0)
          ? labRequest.labRequestReport[0]
          : null;

      const missingDates = [];
      if (!report?.essaysStartedAt) missingDates.push('Fecha de Inicio de Ensayos');
      if (!report?.essaysEndedAt) missingDates.push('Fecha Final de Ensayos');
      if (!report?.endedAt) missingDates.push('Fecha de Informe Final');

      if (missingDates.length > 0) {
        if (missingDates.length === 3) {
          toast.error('Debe registrar la Fecha de Informe Final, Fecha de Inicio de Ensayos y Fecha Final de Ensayos en la pestaña de Informes antes de autorizar.', { autoClose: 6000 });
        } else {
          toast.error(`Falta registrar ${missingDates.join(', ')} en la pestaña de Informes antes de autorizar.`, { autoClose: 6000 });
        }
        return false;
      }
    }
    return true;
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.id),
      trackingStatus: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.trackingStatus) ?? ''
    },
    validationSchema: Yup.object({
      trackingStatus: Yup.string().required("Defina el estatus"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (!validateReportsDates(values.trackingStatus)) {
        return;
      }
      updateTestStatus(values);
      setTimeout(recarga, 900);
    }
  });

  const onUpdate = (values) => {
    setRowInfo(values)
    setShowModal3(true)
  }

  const columns = React.useMemo(
    () => [
      Expander,
      {
        Header: 'Norma',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.norm?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Método',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.method ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Nombre del ensayo',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Estatus',
        width: '8%',
        Cell: ({ row }) => (
          row.original?.statusTest === 'Autorizado' ?
            <div className='text-success'>{row.original?.statusTest}</div> :
            row.original?.statusTest === 'Rechazado' ?
              <div className='text-danger'>{row.original?.statusTest}</div> :
              <div className='text-warning'>{row.original?.statusTest}</div>
        ),
      },
      {
        width: '8%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div id={`test-action-row-${row.original.id}`}>
            <div className="page-title-box d-flex align-items-center justify-content-center row">
              <BaseCustomButton
                disabled={role === userRoles.technicalAdvisor || generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED}
                color="primary"
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-lead-pencil mdi-18px"
                label="Editar"
                onClick={() => onUpdate(row.original)}
              />
              <BaseCustomButton
                tag={Link}
                to={`/addInfoToTest/${id}/${row.original.id}`}
                color="success"
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-clipboard-check mdi-18px"
                label="Detalle"
                onClick={() => {
                  sessionStorage.setItem('scroll_restore_target_id', `test-action-row-${row.original.id}`);
                  const currentY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
                  if (currentY > 0) {
                    sessionStorage.setItem(`scroll_restore_${id}`, currentY.toString());
                  }
                }}
              />
              <BaseCustomButton
                disabled={
                  (role === userRoles.laboratorist) ||
                  (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING) ||
                  (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                }
                color="danger"
                outline
                className="col-10 p-1"
                icon="mdi-delete mdi-18px"
                label="Eliminar"
                onClick={() => { onDelete(row.original) }}
              />
            </div>
          </div>
        ),
      },
    ],
    [role, status, generalStatus]
  )

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'No. muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>

            <div className='text-center mb-2'>Código de muestra: {row.original?.labRequestSample?.sampleControlIdentifier ?? '-'}</div>
            <div className='text-center mb-1'>
              <QRCode value={row.original?.labRequestSample?.sampleControlIdentifier ?? '-'} size={50} />
            </div>
            <div className='text-center'>Folio de muestra: {row.original?.labRequestSample?.serviceIdentifier ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Descripción de la muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Cantidad',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.quantity ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'UM',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.unitMeasure?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Ensayos por muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.essays ?? '-'}</div>
          </div>
        ),
      },
    ],
    []
  )

  const onDelete = (values) => {
    setRowInfo(values);
    setShowModal2(true);
  }

  const onDeleteConfirmation = () => {
    dispatch(deleteLabRequestTest(rowInfo));
    setRowInfo('');
  }

  const getPagination = (params) => {
    dispatch(getLabRequestTests(`${params}&labRequest=${id}`));
  }

  const addPropertyLabRequestTest = (rowIdSelected) => {
    return {
      labRequest: id,
      labTest: rowIdSelected,
      statusTest: 'Pendiente',
      statusLaboratory: 'Pendiente',
      isInLaboratoryOperations: false,
    }
  }

  const RegisterModalRespInfo = (rowsIdSelected) => {
    // rowsIdSelected is an array with the "id" of the tests selected by the user
    Promise.all(
      // Dispatch all elements of the test id array at the same time
      rowsIdSelected.map((rowIdSelected) => dispatch(addNewLabRequestTest(addPropertyLabRequestTest(rowIdSelected))))
    )
  }

  const handleMassiveValidation = (values) => {
    dispatch(massiveStatusUpdate(id, values.statusTest));
    setTimeout(reRender, 600);
  }

  const addProperties = (values) => {
    return {
      ...values,
      id: rowInfo.id,
    }
  }

  const RegisterModalRespInfoUpdate = (values) => {
    dispatch(updateLabRequestTest(addProperties(values)));
    setRowInfo('');
    setTimeout(reRender, 600);
  }

  const handleSaveClick = () => {
    if (!validateReportsDates(validation.values.trackingStatus)) {
      return;
    }
    setConfirmationModal(true);
  };

  const onAccept = () => {
    if (!validateReportsDates(validation.values.trackingStatus)) {
      setConfirmationModal(false);
      return;
    }
    validation.submitForm();
  }

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      <>
        {/* Fetch data if not already available */}
        {(row.original.labRequestTestSample) ? '' : dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}`))}
        <TableNP isAddTableBorderStrap columns={columns2} data={row?.original?.labRequestTestSample} />
      </>
    ),
    []
  )

  return (
    <>
      <Form
        className="form-horizontal mt-2 mb-1"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <div className='d-flex align-items-center pt-1 w-100'>
          {/* Last update component */}
          <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.updatedBy?.surname ?? ''}`}
            date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`} />
        </div>
        {/* Button group */}
        <div className='d-flex align-items-end justify-content-end'>

          <div className='mx-2'>
            <label className='text-primary'>Estatus</label>
            <select
              disabled={(role === userRoles.technicalAdvisor) ||
                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
              }
              name="trackingStatus"
              className="form-select text-primary rounded-3"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.trackingStatus || ""}
            >
              {requestStatus.map((dir, index) => {
                return <option key={index} value={dir.id}>{dir.value}</option>
              })}
            </select>
          </div>

          {
            booleanValidation ? <AnalysisRequestNotifyButton disabled={booleanValidation} />
              : <Link
                to={{
                  pathname: `/process-notification/${id}`,
                }}
              >
                <AnalysisRequestNotifyButton disabled={booleanValidation} />
              </Link>
          }
          <AnalysisRequestSaveButton disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} handleOnClick={handleSaveClick} />
          <ConfirmationModalTestReport props={props} onAccept={onAccept} showModal={confirmationModal} setShowModal={setConfirmationModal} message='¿Está seguro de cambiar el estatus de la solicitud de ensayos?' />
        </div>
      </Form >

      <div className='d-flex align-items-center justify-content-between pt-1'>
        <h6 className='text-success'>Solicitud de ensayos</h6>
        <div className='d-flex align-items-center justify-content-end flex-row'>
          <BaseCustomButton
            className='btn btn-info rounded-3 ms-4'
            disabled={role === userRoles.technicalAdvisor || generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED}
            icon="mdi-18px mdi-checkbox-marked-circle-outline"
            label='Validación Masiva'
            onClick={() => setShowMassiveValidationModal(true)}
          ></BaseCustomButton>
          <AnalysisRequestNewRegisterButton
            disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
            showModal={showModal1}
            setShowModal={setShowModal1}
            text='Registrar Ensayo'
          />
        </div>
        <NewRegisterEssayModal props={props} laboratoryType={labRequest?.laboratoryArea?.laboratoryType?.id} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={RegisterModalRespInfo} />
        <MassiveValidationModal
          setShowModal={setShowMassiveValidationModal}
          showModal={showMassiveValidationModal}
          labRequestId={id}
          labRequest={labRequest}
          labRequestTests={labRequestTests}
          onSuccess={reRender}
        />
      </div>

      <Table1 renderRowSubComponent={renderRowSubComponent} currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestTests} />

      <LabCitecDetailsTestEditModal props={props} modalRespInfo={RegisterModalRespInfoUpdate} setShowModal={setShowModal3} showModal={showModal3} rowInfo={rowInfo} /* extraRender={extraRender} */ modalHeader='Edición de estado' />

      <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Ensayos' modalBodyLabel='¿Está seguro que desea borrar el ensayo seleccionado?' />

    </>
  )
}
